export default __webpack_public_path__ + "static/bg-wave-croped-763953cd7ebdc9c074c9eb7963e79366.png";